import React from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { Variant } from 'shared/store/product/types';


interface SizeProps {
  variants: Variant[];
  currentVariantId: string;
  changeVariant: (id: string) => void;
}


const Wrap = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing80}
  0 ${({ theme }) => theme.spacing.spacing40};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: stretch;
  max-width: 600px;
`;


const SizeButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  margin: 0 ${({ theme }) => theme.spacing.spacing20} ${({ theme }) => theme.spacing.spacing40} 0;

  &:focus {
    outline: none;
  }
  &.oos {
    opacity: 0.5;
  }
`;


const SizeInfo = styled.span`
  ${({ theme }) => theme.borders.border100};
  border-color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.52)};
  border-radius: 15px;
  padding: ${({ theme }) => theme.spacing.spacing20} ${({ theme }) => theme.spacing.spacing60};
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  display: block;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-align: center;
  cursor: pointer;
  ${({ theme }) => theme.typography.bodyLarge};

  &.active {
    background: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.82)};
    color: ${({ theme }) => theme.colors.white};
    ${({ theme }) => theme.typography.subTitleLarge};
  }

  &.oos {
    ${({ theme }) => theme.borders.border100};
    border-color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.42)};
    border-radius: 15px;
    background: transparent;
    font-weight: normal;
    opacity: 0.9px;
    color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.42)};
  }
`;


const Sizes = ({
  variants,
  currentVariantId,
  changeVariant,
}: SizeProps) => (
  <Wrap>
    {
        variants.map((variant) => {
          const { packSize, quantity, childId } = variant;
          const isVariantOutOfStock = (quantity === 0);
          const isVariantSelected = (childId === currentVariantId);
          let additionalClassForShade = `${isVariantSelected ? 'active' : ''}`;

          if (isVariantOutOfStock) {
            additionalClassForShade += ' oos';
          }

          return (
            <SizeButton
              type="button"
              key={childId}
              onClick={() => changeVariant(childId)}
              className={additionalClassForShade}
            >
              <SizeInfo className={additionalClassForShade}>
                {packSize}
              </SizeInfo>
            </SizeButton>
          );
        })
      }
  </Wrap>
  );


export default Sizes;
